'use strict';

var Model = require('base/Colido.Model')

/**
 * Model for a single currency
 *
 * @category   Model
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var CurrencyModel = Model.extend({
    api: '/core/currencies',

    idAttribute: 'key',

    defaults: {
        key: '',
        exchangeRate: 1,
    },

    customAttributes: {
        name: function() {
            return App.t('global::currencies:' + this.get('key') + ':long');
        },
        shortName: function() {
            return App.t('global::currencies:' + this.get('key') + ':short');
        },
    },
});

module.exports = CurrencyModel;